import Layout from "components/Layout";
import RCAAppDrawerItems from "../RCAAppDrawerItems";
import { IRCALayout } from "./RCALayoutInterfaces";
import Module2Icon from "components/Module2Icon";
import { useStyles } from "./RCALayout.styles";

const RCALayout = ({ children }: IRCALayout) => {
    const classes = useStyles();
    return (
        <Layout
            rca
            appDrawerItems={<RCAAppDrawerItems />}
            toolbarLogo={
                <>
                    <Module2Icon /> <span className={classes.mainTitle}>RCA/AP</span>
                </>
            }
        >
            {children}
        </Layout>
    );
};

export default RCALayout;
